<template>

  <HeaderSection />

  <div class="container mx-auto max-w-4xl my-7 p-0 min-h-screen">
    <div class="w-full px-2 py-4 mx-auto text-center">
        <button @click="descargar" class="px-4 py-2 bg-white border-[#243665] hover:bg-[#243665] text-[#243665] font-semibold hover:text-white border rounded-xl">
          <i class="pi pi-arrow-circle-down mr-2"></i>{{ $t('boton.descargar.credencial') }}
        </button>
    </div>
    <div class="w-full px-2">
      <img :src="formData.link"/>
    </div>
    <div class="w-full px-2 py-4 mx-auto text-center">
        <button @click="salir" class="px-4 py-2 bg-white border-[#243665] hover:bg-[#243665] text-[#243665] font-semibold hover:text-white border rounded-xl">
          <i class="pi pi-sign-out mr-2"></i>{{ $t('global.salir') }}
        </button>
    </div>

  </div>

  <FooterSection />

</template>

<script lang="ts">
import { useRoute } from 'vue-router'

import { defineComponent } from 'vue';
import Swal from 'sweetalert2'

import HeaderSection from './HeaderSection.vue';
import FooterSection from './FooterSection.vue';

import suiteService, { Acreditado } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { VERIFICADO } from 'qreventos-suite/constantes';

export default defineComponent({
  components: {
    HeaderSection, FooterSection
  },
  data() {
    return {
      formData: {
        link: '',
      }
    };
  },
  methods: {
    descargar() {
      window.location.href = this.formData.link;
    },
    salir() {
      this.$router.push({ path: '/' });
    }
  },
  async mounted() {
    const route = useRoute();
    const hash = route.params.hash as string;

    const acreditado: Acreditado = await suiteService.findAcreditadoByHash(suiteConfig.evento, hash);
    if (!acreditado) {
      Swal.fire({ title: "Atención!!!", html: this.$t('mensaje.acreditado.no.existe'), icon: "error" }).then(() => {
        this.$router.push({ path: '/' }).then(() => { this.$router.go(0) });
      });
      return;
    }

    if (acreditado.estadoAcreditado.id != VERIFICADO) {
      Swal.fire({ title: this.$t('global.atencion'), html: this.$t('mensaje.acreditcion.no.verificada'), icon: "error" });
      return;
    }

    this.formData.link = "https://apps.qreventos.com/credencial/getCredencial?evento=" + suiteConfig.evento + "&hash=" + acreditado.hash + "&pdf=false";
  
  }
});
</script>
